export enum NavigationLinkType {
    Menu = '/menu',
    Gallery = '/gallery',
    Contact = '/contacts',
}
